import { useEffect, useRef, useState } from "react";
import {
  DateInput,
  FileInput,
  RadioInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
// import ReactQuill, { Quill } from "react-quill";
import Button from "../../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../components/common/table/Table";
import editIcon from "../../../../assets/svg/edit-icon.svg";

import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import { postFormAction } from "../../../../_store/post.slice";
import { useLocation } from "react-router-dom";
import postSchema from "../../../../validation/Admin/PostSchema";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import { history } from "../../../../_helpers";
import Swal from "sweetalert2";
import deleteIcon from "../../../../assets/svg/delete-icon.svg";
import { Popup } from "../../../../components/common/ui/NotificationModal/Popup";
import FroalaEditor from "react-froala-wysiwyg";
import { config } from "../../Editor_Config/Froalaconfig";
import CustomLoader from "../../../../components/common/ui/Loader";
const CommitteePostPage = () => {
  const dispatch = useDispatch();
  const { postForm, getPostFormListResponse, loading } = useSelector(
    (x) => x.post
  );

  const isFirstRender = useRef(true);
  const [errorMessage, setErrorMessage] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const [editRow, setEditRow] = useState({});
  const [createPost, setCreatePost] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);
  const location = useLocation();
  const committee = location?.state?.committee;
  const totalCount = getPostFormListResponse?.data?.totalItems || 0;

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  const [Filters, SetFilters] = useState({
    title: "",
    startDateTime: "",
    endDateTime: "",
    status: true,
  });

  const [apiParams, setApiParams] = useState(
    `page=${1}&limit=${10}&status=${true}`
  );
  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  useEffect(() => {
    const resetHandler = () => {
      setIsEditMode(false);
      setCreatePost(false);
    };

    window.addEventListener("resetPostsPage", resetHandler);
    return () => {
      window.removeEventListener("resetPostsPage", resetHandler);
    };
  }, []);

  const [deletedFiles, setDeletedFiles] = useState([]);

  useEffect(() => {
    Swal.close();
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(Filters).filter(([_, v]) => v !== "")
      ),
    }).toString();

    setApiParams(`&${query}`);
  }, [Filters]);

  useEffect(() => {
    debugger;
    if (!committee) return;

    const searchParams = `?committeeId=${committee?._id + apiParams}`;
    dispatch(postFormAction?.getPostFormList(searchParams));

    !isEditMode && dispatch(postFormAction?.resetForm({}));
  }, [committee]);

  const columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Created at",
      // selector: (row) => {
      //   return new Date(row.createdAt).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      // },
      selector: (row) => {
        const formatted = new Date(row.createdAt).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // use "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },

      sortable: false,
    },
    {
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size"
            onClick={() => {
              editEvent(row);
            }}
          />
          <img
            src={deleteIcon}
            title="Delete"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleDelete(row);
            }}
          />
          <ToggleSwitch
            name={`Status${row.InmateID}`}
            id={`Status${row.InmateID}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleMemberStatus(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];
  // const config = {
  //   // key: `${process.env.REACT_APP_API_Froala_Key}`, // Key for Froala
  //   placeholderText: "Start typing...",
  //   charCounterCount: true,
  //   toolbarButtons: [
  //     "bold",
  //     "italic",
  //     "underline",
  //     "strikeThrough",
  //     "subscript",
  //     "superscript",
  //     "|",
  //     "fontFamily",
  //     "fontSize",
  //     "color",
  //     "inlineStyle",
  //     "paragraphStyle",
  //     "|",
  //     "paragraphFormat",
  //     "align",
  //     "formatOL",
  //     "formatUL",
  //     "outdent",
  //     "indent",
  //     "quote",
  //     "|",
  //     "insertLink",
  //     "insertImage",
  //     "insertVideo",
  //     "insertFile",
  //     "insertTable",
  //     "|",
  //     "emoticons",
  //     "specialCharacters",
  //     "embedly",
  //     "insertHR",
  //     "selectAll",
  //     "clearFormatting",
  //     "|",
  //     "print",
  //     "spellChecker",
  //     "help",
  //     "html",
  //     "|",
  //     "undo",
  //     "redo",
  //   ],
  //   toolbarButtonsXS: null,
  //   toolbarButtonsSM: null,
  //   toolbarButtonsMD: null,
  //   imageUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,
  //   // `

  //   // Video upload endpoint (if needed)
  //   videoUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // File upload endpoint
  //   fileUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // Extra settings
  //   imageUploadParam: "file", // 👈 match multer field name
  //   fileUploadParam: "file",
  //   videoUploadParam: "file",
  //   events: {
  //     "image.uploaded": function (response) {
  //       const res = JSON.parse(response);
  //       debugger;
  //       if (res.link) {
  //         this.image.insert(
  //           `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`, // ✅ use IMAGE_URL, not API_URL
  //           true,
  //           null,
  //           this.image.get(),
  //           response
  //         );
  //         return false; // prevent Froala default insert
  //       }
  //     },
  //   },

  //   // Example: image upload endpoint on your server

  //   // Additional options you might use:
  //   // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  //   // fileUploadURL: '/api/uploads/froala-file',
  //   //
  // };

  //   const Size = Quill.import("attributors/style/size");
  //   var Font = Quill.import("formats/font");

  //   Font.whitelist = [
  //     "arial",
  //     "courier-new",
  //     "georgia",
  //     "tahoma",
  //     "times-new-roman",
  //     "verdana",
  //     "impact",
  //     "wingdings",
  //   ];

  //   Size.whitelist = [
  //     "8pt",
  //     "10pt",
  //     "12pt",
  //     "14pt",
  //     "18pt",
  //     "24pt",
  //     "36pt",
  //     "48px",
  //   ];

  //   Quill.register(Size, true);

  //   const modules = {
  //     toolbar: [
  //       [{ font: Font.whitelist }],
  //       [{ size: Size.whitelist }],
  //       ["bold", "italic", "underline", "strike", "blockquote"],
  //       [{ list: "ordered" }, { list: "bullet" }],
  //       [{ script: "sub" }, { script: "super" }],
  //       [{ indent: "-1" }, { indent: "+1" }],
  //       [{ direction: "rtl" }],
  //       [{ color: [] }, { background: [] }],
  //       [{ align: [] }],
  //       ["link"],
  //       ["clean"],
  //       ["code-block"],
  //       ["htmlEditButton"],
  //     ],
  //     clipboard: {
  //       matchVisual: false,
  //     },
  //   };

  //   const CustomStyles = `
  // .ql-picker.ql-font .ql-picker-label::before,
  // .ql-picker.ql-font .ql-picker-item::before {
  //     font-family: initial !important;  /* Reset to default font */
  //     content: attr(data-value) !important;  /* Show font name */
  //     text-transform: capitalize !important;  /* Capitalize first letter */
  //     font-size: 16px !important;  /* Increase font size */
  // }

  //   .ql-picker.ql-font { width: 160px !important; }

  //     .ql-picker.ql-size .ql-picker-label::before,
  //     .ql-picker.ql-size .ql-picker-item::before {
  //         content: attr(data-value) !important;
  //         text-transform: none !important;
  //     }
  //         .ql-font-arial { font-family: Arial, sans-serif; }
  //         .ql-font-courier-new { font-family: Courier-New, monospace; }
  //         .ql-font-georgia { font-family: Georgia, serif; }
  //         .ql-font-tahoma { font-family: Tahoma, sans-serif; }
  //         .ql-font-times-new-roman { font-family: Times-New-Roman, serif; }
  //         .ql-font-verdana { font-family: Verdana, sans-serif; }
  //         .ql-font-impact { font-family: Impact, sans-serif; }
  //         .ql-font-wingdings { font-family: Wingdings; }

  //          /* Hide only the preview inside the tooltip */
  //         .ql-tooltip .ql-preview {
  //             max-width: 7px !important;
  //             height: 0px !important;
  //             overflow: hidden !important;
  //             white-space: nowrap !important;
  //             display: inline-block !important;
  //             visibility: hidden; /* Hides text but keeps the element */
  //         }
  //         .ql-snow .ql-tooltip::before {
  //             content: none !important; /* Removes the "Visit URL:" text */
  //         }
  //       .ql-snow .ql-tooltip a.ql-action::after {
  //           border-right: 1px solid #ccc;
  //           content: 'Edit';
  //           margin-left: 7px;
  //           padding-right: 8px;
  //       }
  // `;

  const handleDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the post?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        dispatch(postFormAction?.deletePost(row?._id))
          .then((result) => {
             setIsPending(false);
            if (result?.payload?.status === 1) {
             
              showToastNotification(result?.payload?.message, "success");
              const searchParams = `?committeeId=${committee?._id + apiParams}`;
              dispatch(postFormAction?.getPostFormList(searchParams));
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to delete post", "error");
          });
      },
    });
  };

  const handleEditorChanges = (content, name) => {
    if (isFirstRender.current) return;
    const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
    dispatch(postFormAction.updateForm({ [name]: cleanedContent }));
  };
  const handleChange = (e, keyFromSelect) => {
    const updatedForm = { ...postForm };

    if (keyFromSelect) {
      updatedForm[keyFromSelect] = e;
    } else {
      const { name, value, type } = e?.target;
      //  formData[name] =
      // type === "radio" ? (value === "true" ? true : false) : value;
      updatedForm[name] =
        type === "radio" ? (value === "true" ? true : false) : value;
      // updatedForm[name] = value;
    }

    dispatch(postFormAction.updateForm(updatedForm));
  };

  const handleFileChange = (e) => {
    debugger;
    const files = e?.target?.files;
    if (!files || files.length === 0) return;
    const updatedForm = { ...postForm, files: files };
    dispatch(postFormAction.updateForm(updatedForm));
  };

  const handleReset = (e) => {
    e.preventDefault();
    setErrorMessage({});
    isEditMode
      ? dispatch(postFormAction?.updateForm(editRow))
      : dispatch(
          postFormAction.updateForm({
            title: "",
            description: "",
          })
        );
  };

  const handleMemberStatus = (e, row) => {
    dispatch(
      postFormAction.togglePostForm({ id: row?._id, status: !row.status })
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          const searchParams = `?committeeId=${committee?._id + apiParams}`;
          dispatch(postFormAction?.getPostFormList(searchParams));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };

  const editEvent = (row) => {
    debugger;
    setEditRow(row);
    const eventRow = { ...row };
    eventRow["uploadedDoc"] = eventRow["files"];
    eventRow["files"] = [];
    setDeletedFiles([]);
    setIsEditMode(true);
    setCreatePost(false);
    dispatch(postFormAction?.updateForm(eventRow));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setErrorMessage({});
    setIsPending(true);
    const form = { ...postForm };
    form["committee"] = committee?._id;
    form["postID"] = form?._id;
    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key] !== undefined && form[key] !== null) {
        if (key === "files" && form[key] instanceof FileList) {
          Array.from(form[key]).forEach((file) => {
            formData.append("files", file);
          });
        } else if (key === "files" && Array.isArray(form[key])) {
          form[key].forEach((file) => {
            formData.append("files", file);
          });
        } else if (key === "deletedFiles" && Array.isArray(form[key])) {
          form[key].forEach((fileId) => {
            formData.append("deletedFiles[]", fileId);
          });
        } else {
          formData.append(key, form[key]);
        }
      }
    });
    dispatch(postFormAction?.updateForm(form));
    const { error } = postSchema(form);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    const request = isEditMode
      ? dispatch(postFormAction?.updatePostForm(formData))
      : dispatch(postFormAction?.createPostForm(formData));
    request
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          setCreatePost(false);
          // setIsEditMode(false);
          setEditRow({});
          showToastNotification(result?.payload?.message, "success");
          const searchParams = `?committeeId=${committee?._id + apiParams}`;
          dispatch(postFormAction?.getPostFormList(searchParams));
          // dispatch(postFormAction?.getPostFormList(committee?._id));
          dispatch(postFormAction?.resetForm({}));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        setIsPending(false);
        showToastNotification("Failed to create member", "error");
      });

    if (isEditMode) {
      setIsEditMode(false); // Exit edit mode after successful update
    }
  };

  const handleRowPerPage = (limitcount) => {
    debugger;
    const updatedParams = apiParams
      .replace(/&limit=\d+/, `&limit=${limitcount}`)
      .replace(/([?])page=\d+/, `$1page=${1}`)
      .replace(/^&/, "&");

    const searchParams = `?committeeId=${committee?._id + updatedParams}`;
    setApiParams(updatedParams);
    dispatch(postFormAction?.getPostFormList(searchParams));
    setRowCountPerPage(limitcount);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    debugger;
    const updatedParams = apiParams
      .replace(/([?&])page=\d+/, `&page=${page}`)
      .replace(/^&/, "&");
    setApiParams(updatedParams);
    const searchParams = `?committeeId=${committee?._id + updatedParams}`;
    dispatch(postFormAction?.getPostFormList(searchParams));
    setPageNo(page);
  };

  //search
  const handleSearchChange = (e, name) => {
    let duplicate = { ...Filters };
    if (name === "startDateTime" || name === "endDateTime") {
      duplicate[name] = e;
    } else {
      const { type, value } = e?.target;
      duplicate[name] =
        type === "radio" ? (value === "true" ? true : false) : value;
      // duplicate[name] = (e?.target?.value || "").trimStart();
    }
    SetFilters(duplicate);
  };

  const handleSearchSubmit = (e) => {
    debugger;
    e.preventDefault();
    const searchParams = `?committeeId=${committee?._id + apiParams}`;
    dispatch(postFormAction?.getPostFormList(searchParams));
  };

  const handleSearchFormReset = (e) => {
    debugger;
    e.preventDefault();
    const searchParams = `?committeeId=${
      committee?._id
    }&page=${1}&limit=${10}&status=${true}`;
    dispatch(postFormAction?.getPostFormList(searchParams));
    SetFilters({
      title: "",
      startDateTime: "",
      endDateTime: "",
      status: true,
    });
  };

  function truncateText(text, maxLength) {
    if (!text) return "";
    const plainText = text.replace(/<[^>]+>/g, ""); // strip HTML tags
    if (plainText.length <= maxLength) return text;
    return plainText.substring(0, maxLength) + "...";
  }

  const handleDeleteDoc = (file) => {
    debugger;
    const docList = [...deletedFiles];
    docList.push(file?._id);
    setDeletedFiles(docList);
    const updatedForm = { ...postForm, deletedFiles: docList };
    dispatch(postFormAction.updateForm(updatedForm));
    // showToastNotification("File deleted successfully", "success");
  };

  // console.log(postForm, "postForm");
  if (loading) return <CustomLoader />;
  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">{committee?.committeeName}</h1>
        <div>
          {createPost === false && (
            <Button
              className="me-2"
              label="Create"
              status="secondary"
              onClick={() => {
                setCreatePost(true);
                setIsEditMode(false);
                dispatch(postFormAction?.resetForm({}));
              }}
            />
          )}

          <Button
            label="Back"
            status="reset"
            // onClick={() => {
            //   history.navigate("/Admin/CommitteePage");
            // }}
            onClick={() => {
              setErrorMessage({});
              isEditMode === false && createPost === false
                ? history?.navigate("/Admin/CommitteePage")
                : setIsEditMode(false);
              setCreatePost(false);
            }}
          />
        </div>
      </div>

      {isEditMode === false && createPost === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
            Search Posts
          </h1>

          <form
            className="p-3 row"
            onSubmit={(e) => {
              handleSearchSubmit(e);
            }}
            onReset={(e) => {
              handleSearchFormReset(e);
            }}
          >
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                name="title"
                id="title"
                handleChange={(e) => handleSearchChange(e, "title")}
                value={Filters?.title}
              />
            </div>

            <div className="col-md-4">
              <DateInput
                name="start"
                id="start"
                handleChange={(e) => {
                  handleSearchChange(e, "startDateTime");
                }}
                placeholder="Select Date"
                // showTimeSelect={true}
                label={"Start Date & Time"}
                value={Filters?.startDateTime}
                isClearable={Filters?.startDateTime}
                // minTime={
                //   isSameDay(
                //     Filters?.startDateTime
                //       ? new Date(Filters?.startDateTime)
                //       : new Date(),
                //     new Date()
                //   )
                //     ? new Date()
                //     : new Date(new Date().setHours(0, 0, 0, 0))
                // }
                // maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
                // minDate={new Date()}
                maxDate={Filters?.endDateTime}
              />
            </div>
            <div className="col-md-4">
              <DateInput
                name="end"
                id="end"
                value={Filters?.endDateTime}
                handleChange={(e) => {
                  handleSearchChange(e, "endDateTime");
                }}
                placeholder="Select Date"
                // showTimeSelect={true}
                label={"End Date & Time"}
                isClearable={Filters?.endDateTime}
                minDate={Filters?.startDateTime}
                // minTime={
                //   !isSameDay(
                //     Filters?.startDateTime,
                //     Filters?.startDateTime === ""
                //       ? Filters?.startDateTime
                //       : Filters?.endDateTime
                //   )
                //     ? new Date(new Date().setHours(0, 0, 0, 0))
                //     : Filters?.startDateTime
                // }
                // maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => {
                  handleSearchChange(e, "status");
                }}
                selectedValue={Filters?.status}
              />
            </div>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
              <Button status="secondary" label="Search" type="submit" />
              <Button status="reset" label="Reset" type="reset" />
            </div>
          </form>
        </div>
      )}

      {(isEditMode || createPost) && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            {!isEditMode ? "Create" : "Edit"} Committee Post
          </h1>

          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            className="p-3 row mb-4"
          >
            <div className="col-md-4">
              <TextInput
                name="title"
                id="title"
                label="Title"
                placeholder="Title"
                handleChange={(e) => {
                  handleChange(e);
                }}
                value={postForm?.title}
                required
                errorMessage={errorMessage}
              />
            </div>
            <div className="col-md-4">
              <FileInput
                acceptFormat=".pdf"
                handleFileChange={(e) => {
                  handleFileChange(e);
                }}
                label="File"
                multiple
              />
               <p className="text-gray fs-6">
                Supported File type : (PDF, DOC, DOCX, JPG, PNG)
              </p>
              {postForm?.uploadedDoc?.length > deletedFiles?.length && (
                <div className="bg-light rounded p-3 mb-2">
                  <dl className="mt-2 p-2">
                    <dt className="text-dark">File Name:</dt>
                    {isEditMode &&
                      postForm?.uploadedDoc &&
                      postForm?.uploadedDoc?.map((file) => {
                        return (
                          <>
                            {!deletedFiles.includes(file?._id) && (
                              <div className="d-flex gap-2">
                                <dd className="name">
                                  {truncateText(file?.file, 38)}
                                </dd>
                                <img
                                  src={deleteIcon}
                                  title="Edit"
                                  alt="edit-icon"
                                  aria-hidden="true"
                                  height="20px"
                                  width="20px"
                                  className="cursor-pointer cursor-pointer"
                                  onClick={() => {
                                    handleDeleteDoc(file);
                                  }}
                                />
                              </div>
                            )}
                          </>
                        );
                      })}
                  </dl>
                </div>
              )}
            </div>
            {/* <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleChange(e)}
                selectedValue={postForm?.status}
              />
            </div> */}

            <div className="mt-2">
              <label
                className={`form-label col-form-label  w-100 fs-5 form-label-custom-visible `}
              >
                Description {<span className="text-danger">*</span>}
              </label>

              <div className="quill-container" id="toolbar">
                {/* <style>{CustomStyles}</style> */}
                <div>
                  {/* <ReactQuill
                    name="description"
                    theme="snow"
                    value={postForm?.description || ""}
                    onChange={(e) => {
                      handleEditorChanges(e, "description");
                    }}
                    className={`editor-block ${
                      errorMessage?.["description"] ? "input-error" : ""
                    }`}
                    modules={modules}
                  /> */}
                  <FroalaEditor
                    tag="textarea"
                    name="description"
                    config={config} // your toolbar, plugins, etc.
                    model={postForm?.description || ""} // ✅ value binding
                    onModelChange={(e) => {
                      // ✅ onChange equivalent
                      handleEditorChanges(e, "description");
                    }}
                    className={`editor-block ${
                      errorMessage?.["description"] ? "input-error" : ""
                    }`}
                  />
                </div>
              </div>
              {errorMessage?.description && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.description}
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
              <Button
                label={isEditMode ? "Update" : "Add"}
                status="primary"
                type="submit"
                disabled={isPending}
              />
              <Button
                label="Reset"
                status="reset"
                type="reset"
                onClick={(e) => {
                  handleReset(e);
                }}
              />
            </div>
          </form>
        </div>
      )}
      {isEditMode === false && createPost === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color p-3 ">Posts List</h1>
          <Table
            columns={columns}
            data={getPostFormListResponse?.data?.posts}
            pagination
            onChangeRowsPerPage={(page) => handleRowPerPage(page)}
            onChangePage={(page) => handlePageChange(page)}
            totalRowCount={totalCount || 0}
            currentPage={pageNo}
            paginationPerPage={rowCountPerPage}
          />
        </div>
      )}
    </div>
  );
};

export default CommitteePostPage;
